import * as React from "react";
import { forwardRef } from "react";
const ArrowRightIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 16 16",
  fill: "currentColor",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M.999994 8.99999H12.586L9.29299 12.293c-.391.391-.391 1.023 0 1.414s1.02301.391 1.41401 0l5-5.00001c.391-.391.391-1.023 0-1.414l-5-5c-.195-.195-.451-.293-.70701-.293-.256 0-.512.098-.707.293-.391.391-.391 1.023 0 1.414l3.29301 3.293H.999994c-.552999 0-.99999972.448-.99999972 1s.44700072 1 .99999972 1",
  clipRule: "evenodd"
}));
const ForwardRef = forwardRef(ArrowRightIcon);
export { ForwardRef as ArrowRightIcon };